import React, {
  MutableRefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Message } from "../../types";
import { ZoomChatImage } from "..";
import { TiDocumentText } from "react-icons/ti";
import { getFileDetails } from "../../utils/fileDetails";
import { downloadFileWithProgress } from "../../utils/downloadPPDF";

type DummyRefType = MutableRefObject<HTMLDivElement | null>;

type MessagesProps = {
  chat: Message;
  userID: string | null;
  currentTime: string;
  margin?: string;
};
const Messages: React.FC<MessagesProps> = ({
  chat,
  userID,
  currentTime,
  margin,
}) => {
  const maxLength = 400;
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleExpandToggle = () => {
    if (setIsExpanded) {
      setIsExpanded((prevExpanded) => !prevExpanded);
    }
  };
  const image = chat?.imageUrl;
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = chat?.imageUrl?.length || 0;

  const handleClick = (index: number) => {
    setShowAllImages(index);
    setCurrentIndex(index);
  };
  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < totalImages - 1 ? prevIndex + 1 : prevIndex
    );
  };
  if (showAllImages !== null) {
    document.body.classList.add("picModal");
    // console.log("its hidden");
  } else {
    document.body.classList.remove("picModal");
  }

  const dummy: DummyRefType = useRef(null);

  const scrollToBottom = () => {
    dummy.current && dummy.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  const [fileDetails, setFileDetails] = useState({} as any);

  useMemo(() => {
    if (chat.fileUrls && Array.isArray(chat.fileUrls)) {
      chat.fileUrls.forEach(async (file) => {
        const details = await getFileDetails(file);
        setFileDetails((prevDetails: any) => ({
          ...prevDetails,
          [file]: details,
        }));
      });
    }
  }, [chat.fileUrls]);

  const [isDownloading, setIsDownloading] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);

  const handleDownload = (url: string, fileName: string) => {
    if (isDownloading) return; // Prevent multiple downloads

    setIsDownloading(true);
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    downloadFileWithProgress(
      url,
      () => {
        setIsDownloading(false);
        console.log("Download cancelled");
      },
      abortController.signal,
      fileName
    ).then(() => {
      setIsDownloading(false);
    });
  };

  return (
    <div>
      {image && showAllImages !== null && totalImages > 0 && (
        <ZoomChatImage
          setShowAllImages={setShowAllImages}
          handleNext={handleNext}
          handlePrev={handlePrev}
          totalImages={totalImages}
          image={image}
          currentIndex={currentIndex}
          key={chat.id + 3}
          margin={margin}
        />
      )}

      {!chat.text &&
        chat?.imageUrl &&
        (chat.imageUrl.length <= 3 ? (
          <div
            className={`relative flex flex-col gap-3 py-1 ${
              userID === chat.senderID ? "items-end" : "items-start"
            }`}
            key={chat.id}
          >
            {chat.imageUrl &&
              chat.imageUrl.map((photo, index) => {
                return (
                  <div
                    className={`p-2 pb-0 rounded max-w-[45%] ${
                      userID === chat.senderID
                        ? "bg-midGreen justify-end"
                        : "bg-gray-200 justify-start"
                    }`}
                    key={index + 2}
                  >
                    {photo !== null && (
                      <div className="w-full lg:h-[200px] h-[150px] overflow-hidden">
                        <img
                          src={photo}
                          alt=""
                          className="cursor-pointer object-cover h-full w-full object-center"
                          onClick={() => handleClick(index)}
                        />
                      </div>
                    )}
                    <span
                      className={`block text-[7px] lg:text-[9.9px] text-right opacity-60 ${
                        userID === chat.senderID
                          ? "text-[#FFFFFF99]"
                          : "text-black"
                      }`}
                    >
                      {currentTime}
                    </span>
                  </div>
                );
              })}
          </div>
        ) : (
          !chat.text &&
          chat.imageUrl &&
          chat.imageUrl?.length > 3 && (
            <div
              className={`flex ${
                userID === chat.senderID ? "justify-end" : "justify-start"
              }`}
            >
              <div
                className={`grid grid-cols-2 p-2  my-3 w-[45%] ${
                  userID === chat.senderID
                    ? "bg-midGreen justify-end"
                    : "bg-gray-200 justify-start"
                }`}
              >
                {chat.imageUrl &&
                  chat.imageUrl.slice(0, 4).map((photo, index) => (
                    <div key={index + 2}>
                      <div
                        className="flex w-full border border-solid relative lg:h-[110px] h-[80px] cursor-pointer"
                        onClick={() => handleClick(index)}
                      >
                        <img
                          src={photo}
                          alt=""
                          className=" object-cover object-center h-full w-full"
                        />

                        {chat.imageUrl?.length > 4 &&
                          index === chat.imageUrl?.slice(0, 4).length - 1 && (
                            <div
                              className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 left-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                              key={index * 4}
                              onClick={() => setShowAllImages(4)}
                            >
                              <p>+ {chat.imageUrl?.length - 4}</p>
                            </div>
                          )}
                      </div>
                    </div>
                  ))}
                <span
                  className={`block col-span-full text-[7px] lg:text-[9.9px] text-right opacity-60 ${
                    userID === chat.senderID ? "text-[#FFFFFF99]" : "text-black"
                  }`}
                >
                  {currentTime}
                </span>
              </div>
            </div>
          )
        ))}
      {chat.fileUrls && (
        <div
          className={`relative flex flex-col gap-3 py-1 ${
            userID === chat.senderID ? "items-end" : "items-start"
          }`}
          key={chat.id}
        >
          {chat.fileUrls.map((file, index) => {
            const details = fileDetails[file];

            return (
              <div
                className={`p-2 rounded max-w-[45%] ${
                  userID === chat.senderID
                    ? "bg-midGreen justify-end"
                    : "bg-gray-200 justify-start"
                }`}
                key={index + 2}
              >
                <div
                  className="flex gap-1 items-center cursor-pointer"
                  onClick={() => handleDownload(file, details.name)}
                >
                  <div>
                    <TiDocumentText
                      size={35}
                      fill={`${userID === chat.senderID ? "white" : "black"} `}
                    />
                  </div>
                  {details && (
                    <div
                      className={`flex flex-col whitespace-pre-line text-wrap break-all font-SegoeUI lg:text-[13px] text-[9px] font-medium ${
                        userID === chat.senderID ? "text-white" : "text-black"
                      }`}
                    >
                      {details.name}
                      <span className="lg:text-[11.50px] text-[7px] font-light">
                        {details.size}
                      </span>
                    </div>
                  )}
                </div>
                <span
                  className={`block lg:text-[9.9px] text-[7px] text-right opacity-60 ${
                    userID === chat.senderID ? "text-[#FFFFFF99]" : "text-black"
                  }`}
                >
                  {currentTime}
                </span>
              </div>
            );
          })}
        </div>
      )}
      {chat.text && (
        <div
          className={`relative flex flex-col gap-3 lg:w-full py-1 ${
            userID === chat.senderID ? "items-end" : "items-start"
          }`}
          key={chat.id}
        >
          <div
            className={`p-2 pb-0 ${
              userID === chat.senderID ? "sent" : "receive"
            }`}
          >
            {chat?.imageUrl &&
              (chat.imageUrl.length <= 2 ? (
                <div className={`relative flex w-full`} key={chat.id + 8}>
                  {chat.imageUrl &&
                    chat.imageUrl.map((photo, index) => (
                      <div
                        className="flex w-full border border-solid cursor-pointer"
                        key={index + 2}
                        onClick={() => handleClick(index)}
                      >
                        {photo !== null && (
                          <img
                            src={photo}
                            alt=""
                            className="object-cover w-full object-center"
                          />
                        )}
                      </div>
                    ))}
                </div>
              ) : chat.imageUrl.length === 3 ? (
                <div className="flex w-full relative">
                  <div className="flex w-[49.8%]">
                    {chat.imageUrl.map(
                      (photo, index) =>
                        index === 0 && (
                          <div
                            className="flex w-full border border-solid cursor-pointer"
                            key={index + 2}
                            onClick={() => handleClick(index)}
                          >
                            {photo !== null && (
                              <img
                                src={photo}
                                alt=""
                                className=" w-full object-cover object-center"
                              />
                            )}
                          </div>
                        )
                    )}
                  </div>
                  <div className="grid grid-rows-2  w-[49.8%]">
                    {chat.imageUrl.map(
                      (photo, index) =>
                        index !== 0 && (
                          <div
                            className="flex w-full border border-solid cursor-pointer"
                            key={index + 2}
                            onClick={() => handleClick(index)}
                          >
                            {photo !== null && (
                              <img
                                src={photo}
                                alt=""
                                className=" object-cover object-center"
                              />
                            )}
                          </div>
                        )
                    )}
                  </div>
                </div>
              ) : (
                chat.imageUrl &&
                chat.imageUrl?.length > 3 && (
                  <div className={`flex w-full`}>
                    <div className={`grid grid-cols-2 w-full `}>
                      {chat.imageUrl &&
                        chat.imageUrl.slice(0, 4).map((photo, index) => (
                          <div key={index + 52}>
                            <div
                              className="flex w-full border border-solid relative h-[120px] cursor-pointer"
                              onClick={() => handleClick(index)}
                            >
                              <img
                                src={photo}
                                alt=""
                                className=" object-cover object-center h-full w-full"
                              />
                              <span className="lg:text-[9.9px] text-[7px] text-[#fff] opacity-50 absolute bottom-1 right-1">
                                {currentTime}
                              </span>
                              {chat.imageUrl?.length > 4 &&
                                index ===
                                  chat.imageUrl?.slice(0, 4).length - 1 && (
                                  <div
                                    className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 left-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                                    key={index * 4}
                                    onClick={() => setShowAllImages(4)}
                                  >
                                    <p>+ {chat.imageUrl?.length - 4}</p>
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )
              ))}
            <div className="whitespace-pre-line text-wrap block break-words hyphens-auto">
              {chat.text && chat.text.length <= maxLength
                ? chat.text
                : isExpanded
                ? chat.text
                : chat.text?.slice(0, maxLength)}
              {chat.text && chat.text.length > maxLength && (
                <span
                  className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                  onClick={handleExpandToggle}
                >
                  {!isExpanded ? "... Read more" : "... See less"}
                </span>
              )}
            </div>
            <span
              className={`block text-[7px] lg:text-[9.9px] text-right opacity-60 ${
                userID === chat.senderID ? "text-[#FFFFFF99]" : "text-black"
              } ${chat.text.length < 8 && "ml-4"}`}
            >
              {currentTime}
            </span>
          </div>
        </div>
      )}
      <div ref={dummy}></div>
    </div>
  );
};

export default Messages;
